
import { Prop, Vue, Component } from 'vue-property-decorator'
import { Route } from '~/config/routes.types'
import { createUrl } from '~/utils/routes'

@Component
export default class AppLink extends Vue {
  @Prop(Object) route: Route
  @Prop(String) anchor: string
  @Prop(Boolean) preventDefault: boolean
  @Prop(Object) params: { [key: string]: string }

  get link() {
    const path: string = createUrl(this.route, this.$shopConfig.shopId, {
      params: this.params,
    })
    return this.anchor ? `${path}#${this.anchor}` : path
  }

  clickHref(event: Event) {
    if (this.preventDefault) {
      event.preventDefault()
    }
  }
}
